import axios from "axios";
import { token, url } from "./Config";

const changeRestaurantStatus = (orderId, status, onSuccess) => {
  let data = new FormData();
  data.append("id", orderId);
  data.append("key", "restaurant_approved_status");
  data.append("value", status);

  const config = {
    method: "patch",
    url: `${url}/order/order-update/`,
    data,
    headers: { Authorization: token },
  };

  axios(config)
    .then((res) => {
      onSuccess();
    })
    .catch((err) => void 0);
};

export { changeRestaurantStatus };
